import { 
  Chart,
  Tooltip,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  BarController,
  BarElement,
  Filler
} from 'chart.js';

// Removed the import of tailwindConfigValue
import { hexToRGB } from '../utils/Utils';

// Register required Chart.js components
Chart.register(
  Tooltip,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  BarController,
  BarElement,
  Filler
);

// Define Chart.js default settings
Chart.defaults.font.family = '"Inter", sans-serif';
Chart.defaults.font.weight = 500;
Chart.defaults.plugins.tooltip.borderWidth = 1;
Chart.defaults.plugins.tooltip.displayColors = false;
Chart.defaults.plugins.tooltip.mode = 'nearest';
Chart.defaults.plugins.tooltip.intersect = false;
Chart.defaults.plugins.tooltip.position = 'nearest';
Chart.defaults.plugins.tooltip.caretSize = 0;
Chart.defaults.plugins.tooltip.caretPadding = 20;
Chart.defaults.plugins.tooltip.cornerRadius = 8;
Chart.defaults.plugins.tooltip.padding = 8;

// Function that generates a gradient for line charts
export const chartAreaGradient = (ctx, chartArea, colorStops) => {
  if (!ctx || !chartArea || !colorStops || colorStops.length === 0) {
    return 'transparent';
  }
  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
  colorStops.forEach(({ stop, color }) => {
    gradient.addColorStop(stop, color);
  });
  return gradient;
};

// Chart colors configuration with hard-coded values
export const chartColors = {
  textColor: {
    light: '#9CA3AF', // gray.400
    dark: '#6B7280',  // gray.500
  },
  gridColor: {
    light: '#F3F4F6',                    // gray.100
    dark: `rgba(${hexToRGB('#374151')}, 0.6)`, // rgba(gray.700, 0.6)
  },
  backdropColor: {
    light: '#FFFFFF', // white
    dark: '#1F2937',  // gray.800
  },
  tooltipTitleColor: {
    light: '#1F2937', // gray.800
    dark: '#F3F4F6',  // gray.100
  },
  tooltipBodyColor: {
    light: '#6B7280', // gray.500
    dark: '#9CA3AF',  // gray.400
  },
  tooltipBgColor: {
    light: '#FFFFFF', // white
    dark: '#374151',  // gray.700
  },
  tooltipBorderColor: {
    light: '#E5E7EB', // gray.200
    dark: '#4B5563',  // gray.600
  },
};

// Initialize Chart.js defaults
Chart.defaults.responsive = true;
Chart.defaults.maintainAspectRatio = false;